import React, { useState, useEffect } from 'react';
import '../App.css';
import './HeroSection.css';
import { GooglePlayButton } from "./GooglePlayButton";
import { AppStoreButton } from './AppStoreButton';
import { useTranslation } from "react-i18next";


function HeroSection() {

  const { t } = useTranslation();

  var [direction, setDirection] = useState('row');

  const changeDirection = () => {
    if (window.innerWidth <= 960) {
      setDirection('column');
    } else {
      setDirection('row');
    }
  };

  useEffect(() => {
    changeDirection();
  }, []);

  window.addEventListener('resize', changeDirection);

  return (
    <div className='hero-container'>
      <image src='/images/wal.jpeg'  />
      <h1>{t('title.welcomeText')}</h1>
      <p>{t('text.whatAreYouWait')}</p>
      <div className='hero-btns'>
        <div
          className="store-buttons-container"
          style={{
            gap: 30,
            flexDirection: direction,
          }}
        >

         
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
